import(/* webpackMode: "eager" */ "/var/www/front/live/eduvalu-front/node_modules/next/dist/client/link.js")